/* eslint-disable max-lines */
/* eslint-disable react/no-unescaped-entities */
import { defaultI18nNs } from '@cocoonspace/shared/config/default-i-18-n-ns-config'
import type { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useEffect } from 'react'

import { MainContainer } from '~/components/atoms/main-container'
import { SeoTags } from '~/components/seo-tags'
import { useTracking } from '~/providers/tracking-provider'

const Page = () => {
	const { track } = useTracking()

	// TODO: Legacy tracking, remove?
	useEffect(() => {
		track.landingPage()
	}, [track])

	return (
		<>
			<SeoTags
				title='Politique de confidentialité - Cocoon Space'
				description='Politique de confidentialité de Cocoon Space'
			/>

			<MainContainer className='prose max-w-[800px]'>
				<div>
					<h1>Politique de confidentialité</h1>

					<p>Sécurité et protection des données personnelles</p>
				</div>

				<div>
					<h2>Définitions</h2>

					<p>
						L'
						<strong>Éditeur</strong>: La personne, physique ou morale, qui édite
						les services de communication au public en ligne.
					</p>

					<p>
						Le <strong>Site</strong>: L'ensemble des sites, pages Internet et
						services en ligne proposés par l'Éditeur.
					</p>

					<p>
						L'
						<strong>Utilisateur</strong>: La personne utilisant le Site et les
						services.
					</p>
				</div>

				<div>
					<h2>Nature des données collectées</h2>

					<p>
						<strong>
							Dans le cadre de l'utilisation des Sites, l'Éditeur est
							susceptible de collecter les catégories de données suivantes
							concernant ses Utilisateurs :
						</strong>
					</p>

					<p>Données d'état-civil, d'identité, d'identification...</p>

					<p>Données de connexion (adresses IP, journaux d'événements...)</p>

					<p>Données de localisation (déplacements, données GPS, GSM...)</p>
				</div>

				<div>
					<h2>Communication des données personnelles à des tiers</h2>

					<p>
						<strong>
							Communication aux autorités sur la base des obligations légales
						</strong>
					</p>

					<p>
						Sur la base des obligations légales, vos données personnelles
						pourront être divulguées en application d'une loi, d'un règlement ou
						en vertu d'une décision d'une autorité réglementaire ou judiciaire
						compétente. De manière générale, nous nous engageons à nous
						conformer à toutes les règles légales qui pourraient empêcher,
						limiter ou réglementer la diffusion d'informations ou de données et
						notamment à se conformer à la Loi n° 78- 17 du 6 janvier 1978
						relative à l'informatique, aux fichiers et aux libertés.
					</p>

					<p>
						<strong>
							Communication à des tiers pour sollicitation commerciale pour des
							produits et services équivalents
						</strong>
					</p>

					<p>
						Si vous avez effectué un achat sur notre Site, nous pouvons, avec
						nos partenaires commerciaux et de manière occasionnelle, vous tenir
						informé de nos nouveaux produits, actualités et offres spéciales,
						par courriel, par courrier postal et par téléphone quant à des
						produits ou services similaires aux produits ou services qui ont
						fait l'objet de votre commande.
					</p>

					<p>
						<strong>
							Communication à des tiers avec restrictions liées aux
							destinataires
						</strong>
					</p>

					<p>
						Les données personnelles que vous nous communiquez lors de votre
						commande sont transmises à nos fournisseurs et filiales pour le
						traitement de celle-ci. Ces informations sont considérées par nos
						fournisseurs et filiales comme étant strictement confidentielles.
					</p>
				</div>

				<div>
					<h2>
						Viralité des conditions de réutilisation des données personnelles
					</h2>

					<p>
						<strong>
							Effectuer les opérations relatives à la gestion des clients
							concernant
						</strong>
					</p>

					<ul>
						<li>
							les contrats ; les commandes ; les livraisons ; les factures ; la
							comptabilité et en particulier la gestion des comptes clients
						</li>

						<li>
							un programme de fidélité au sein d'une entité ou plusieurs entités
							juridiques
						</li>

						<li>
							le suivi de la relation client tel que la réalisation d'enquêtes
							de satisfaction, la gestion des réclamations et du service
							après-vente
						</li>

						<li>
							la sélection de clients pour réaliser des études, sondages et
							tests produits (sauf consentement des personnes concernées
							recueilli dans les conditions prévues à l'article 6, ces
							opérations ne doivent pas conduire à l'établissement de profils
							susceptibles de faire apparaître des données sensibles - origines
							raciales ou ethniques, opinions philosophiques, politiques,
							syndicales, religieuses, vie sexuelle ou santé des personnes)
						</li>
					</ul>

					<p>
						<strong>Effectuer des opérations relatives à la prospection</strong>
					</p>

					<ul>
						<li>
							la gestion d'opérations techniques de prospection (ce qui inclut
							notamment les opérations techniques comme la normalisation,
							l'enrichissement et la déduplication)
						</li>

						<li>
							la sélection de personnes pour réaliser des actions de
							fidélisation, de prospection, de sondage, de test produit et de
							promotion. Sauf consentement des personnes concernées recueilli
							dans les conditions prévues à l'article 6, ces opérations ne
							doivent pas conduire à l'établissement de profils susceptibles de
							faire apparaître des données sensibles (origines raciales ou
							ethniques, opinions philosophiques, politiques, syndicales,
							religieuses, vie sexuelle ou santé des personnes)
						</li>

						<li>la réalisation d'opérations de sollicitations</li>
					</ul>

					<p>
						<strong>L'élaboration de statistiques commerciales</strong>
					</p>
				</div>

				<div>
					<h2>Agrégation des données</h2>

					<p>
						<strong>Agrégation avec des données non personnelles</strong>
					</p>

					<p>
						Nous pouvons publier, divulguer et utiliser les informations
						agrégées (informations relatives à tous nos Utilisateurs ou à des
						groupes ou catégories spécifiques d'Utilisateurs que nous combinons
						de manière à ce qu'un Utilisateur individuel ne puisse plus être
						identifié ou mentionné) et les informations non personnelles à des
						fins d'analyse du secteur et du marché, de profilage démographique,
						à des fins promotionnelles et publicitaires et à d'autres fins
						commerciales.
					</p>

					<p>
						<strong>
							Agrégation avec des données personnelles disponibles sur les
							comptes sociaux de l'Utilisateur
						</strong>
					</p>

					<p>
						Si vous connectez votre compte à un compte d'un autre service afin
						de faire des envois croisés, ledit service pourra nous communiquer
						vos informations de profil, de connexion, ainsi que toute autre
						information dont vous avez autorisé la divulgation. Nous pouvons
						agréger les informations relatives à tous nos autres Utilisateurs,
						groupes, comptes, aux données personnelles disponibles sur
						l'Utilisateur.
					</p>
				</div>

				<div>
					<h2>Collecte des données d'identité</h2>

					<p>
						<strong>Consultation libre</strong>
					</p>

					<p>
						La consultation du Site ne nécessite pas d'inscription ni
						d'identification préalable. Elle peut s'effectuer sans que vous ne
						communiquiez de données nominatives vous concernant (nom, prénom,
						adresse, etc). Nous ne procédons à aucun enregistrement de données
						nominatives pour la simple consultation du Site.
					</p>
				</div>

				<div>
					<h2>Collecte des données d'identification</h2>

					<p>
						<strong>
							Utilisation de l'identifiant de l'utilisateur uniquement pour
							l'accès aux services
						</strong>
					</p>

					<p>
						Nous utilisons vos identifiants électroniques seulement pour et
						pendant l'exécution du contrat.
					</p>
				</div>

				<div>
					<h2>Collecte des données du terminal</h2>

					<p>
						<strong>Aucune collecte des données techniques</strong>
					</p>

					<p>
						Nous ne collectons et ne conservons aucune donnée technique de votre
						appareil (adresse IP, fournisseur d'accès à Internet...).
					</p>
				</div>

				<div>
					<h2>Cookies</h2>

					<p>
						<strong>Durée de conservation des cookies</strong>
					</p>

					<p>
						Conformément aux recommandations de la CNIL, la durée maximale de
						conservation des cookies est de 13 mois au maximum après leur
						premier dépôt dans le terminal de l'Utilisateur, tout comme la durée
						de la validité du consentement de l'Utilisateur à l'utilisation de
						ces cookies. La durée de vie des cookies n'est pas prolongée à
						chaque visite. Le consentement de l'Utilisateur devra donc être
						renouvelé à l'issue de ce délai.
					</p>

					<p>
						<strong>Finalité cookies</strong>
					</p>

					<p>
						Les cookies peuvent être utilisés pour des fins statistiques
						notamment pour optimiser les services rendus à l'Utilisateur, à
						partir du traitement des informations concernant la fréquence
						d'accès, la personnalisation des pages ainsi que les opérations
						réalisées et les informations consultées. Vous êtes informé que
						l'Éditeur est susceptible de déposer des cookies sur votre terminal.
						Le cookie enregistre des informations relatives à la navigation sur
						le service (les pages que vous avez consultées, la date et l'heure
						de la consultation...) que nous pourrons lire lors de vos visites
						ultérieures.
					</p>

					<p>
						<strong>
							Droit de l'Utilisateur de refuser les cookies, la désactivation
							entraînant un fonctionnement dégradé du service
						</strong>
					</p>

					<p>
						Vous reconnaissez avoir été informé que l'Éditeur peut avoir recours
						à des cookies, et l'y autorisez. Si vous ne souhaitez pas que des
						cookies soient utilisés sur votre terminal, la plupart des
						navigateurs vous permettent de désactiver les cookies en passant par
						les options de réglage. Toutefois, vous êtes informé que certains
						services sont susceptibles de ne plus fonctionner correctement.
					</p>

					<p>
						<strong>
							Association possible des cookies avec des données personnelles
							pour permettre le fonctionnement du service
						</strong>
					</p>

					<p>
						L'Éditeur peut être amené à recueillir des informations de
						navigation via l'utilisation de cookies.
					</p>
				</div>

				<div>
					<h2>Conservation des données techniques</h2>

					<p>
						<strong>Durée de conservation des données techniques</strong>
					</p>

					<p>
						Les données techniques sont conservées pour la durée strictement
						nécessaire à la réalisation des finalités visées ci-avant.
					</p>
				</div>

				<div>
					<h2>
						Délai de conservation des données personnelles et d'anonymisation
					</h2>

					<p>
						<strong>
							Conservation des données pendant la durée de la relation
							contractuelle
						</strong>
					</p>

					<p>
						Conformément à l'article 6-5° de la loi n°78-17 du 6 janvier 1978
						relative à l'informatique, aux fichiers et aux libertés, les données
						à caractère personnel faisant l'objet d'un traitement ne sont pas
						conservées au-delà du temps nécessaire à l'exécution des obligations
						définies lors de la conclusion du contrat ou de la durée prédéfinie
						de la relation contractuelle.
					</p>

					<p>
						<strong>
							Conservation des données anonymisées au delà de la relation
							contractuelle / après la suppression du compte
						</strong>
					</p>

					<p>
						Nous conservons les données personnelles pour la durée strictement
						nécessaire à la réalisation des finalités décrites dans les
						présentes CGU. Au-delà de cette durée, elles seront anonymisées et
						conservées à des fins exclusivement statistiques et ne donneront
						lieu à aucune exploitation, de quelque nature que ce soit.
					</p>

					<p>
						<strong>Suppression des données après suppression du compte</strong>
					</p>

					<p>
						Des moyens de purge de données sont mis en place afin d'en prévoir
						la suppression effective dès lors que la durée de conservation ou
						d'archivage nécessaire à l'accomplissement des finalités déterminées
						ou imposées est atteinte. Conformément à la loi n°78-17 du 6 janvier
						1978 relative à l'informatique, aux fichiers et aux libertés, vous
						disposez par ailleurs d'un droit de suppression sur vos données que
						vous pouvez exercer à tout moment en prenant contact avec l'Éditeur.
					</p>

					<p>
						<strong>Suppression des données après 3 ans d'inactivité</strong>
					</p>

					<p>
						Pour des raisons de sécurité, si vous ne vous êtes pas authentifié
						sur le Site pendant une période de trois ans, vous recevrez un
						e-mail vous invitant à vous connecter dans les plus brefs délais,
						sans quoi vos données seront supprimées de nos bases de données.
					</p>
				</div>

				<div>
					<h2>Suppression du compte</h2>

					<p>
						<strong>Suppression du compte à la demande</strong>
					</p>

					<p>
						L'Utilisateur a la possibilité de supprimer son Compte à tout
						moment, par simple demande à l'Éditeur OU par le menu de suppression
						de Compte présent dans les paramètres du Compte le cas échéant.
					</p>

					<p>
						<strong>Suppression du compte en cas de violation des CGU</strong>
					</p>

					<p>
						En cas de violation d'une ou de plusieurs dispositions des CGU ou de
						tout autre document incorporé aux présentes par référence, l'Éditeur
						se réserve le droit de mettre fin ou restreindre sans aucun
						avertissement préalable et à sa seule discrétion, votre usage et
						accès aux services, à votre compte et à tous les Sites.
					</p>
				</div>

				<div>
					<h2>
						Indications en cas de faille de sécurité décelée par l'Éditeur
					</h2>

					<p>
						<strong>
							Information de l'Utilisateur en cas de faille de sécurité
						</strong>
					</p>

					<p>
						Nous nous engageons à mettre en oeuvre toutes les mesures techniques
						et organisationnelles appropriées afin de garantir un niveau de
						sécurité adapté au regard des risques d'accès accidentels, non
						autorisés ou illégaux, de divulgation, d'altération, de perte ou
						encore de destruction des données personnelles vous concernant. Dans
						l'éventualité où nous prendrions connaissance d'un accès illégal aux
						données personnelles vous concernant stockées sur nos serveurs ou
						ceux de nos prestataires, ou d'un accès non autorisé ayant pour
						conséquence la réalisation des risques identifiés ci-dessus, nous
						nous engageons à :
					</p>

					<ul>
						<li>Vous notifier l'incident dans les plus brefs délais</li>

						<li>Examiner les causes de l'incident et vous en informer</li>

						<li>
							Prendre les mesures nécessaires dans la limite du raisonnable afin
							d'amoindrir les effets négatifs et préjudices pouvant résulter
							dudit incident
						</li>
					</ul>

					<p>
						<strong>Limitation de la responsabilité</strong>
					</p>

					<p>
						En aucun cas les engagements définis au point ci-dessus relatifs à
						la notification en cas de faille de sécurité ne peuvent être
						assimilés à une quelconque reconnaissance de faute ou de
						responsabilité quant à la survenance de l'incident en question.
					</p>
				</div>

				<div>
					<h2>Transfert des données personnelles à l'étranger</h2>

					<p>
						<strong>Pas de transfert en dehors de l'Union européenne</strong>
					</p>

					<p>
						L'Éditeur s'engage à ne pas transférer les données personnelles de
						ses Utilisateurs en dehors de l'Union européenne.
					</p>
				</div>

				<div>
					<h2>Modification des CGU et de la politique de confidentialité</h2>

					<p>
						<strong>
							En cas de modification des présentes CGU, engagement de ne pas
							baisser le niveau de confidentialité de manière substantielle sans
							l'information préalable des personnes concernées
						</strong>
					</p>

					<p>
						Nous nous engageons à vous informer en cas de modification
						substantielle des présentes CGU, et à ne pas baisser le niveau de
						confidentialité de vos données de manière substantielle sans vous en
						informer et obtenir votre consentement.
					</p>
				</div>

				<div>
					<h2>Droit applicable et modalités de recours</h2>

					<p>
						<strong>Clause d'arbitrage</strong>
					</p>

					<p>
						Vous acceptez expressément que tout litige susceptible de naître du
						fait des présentes CGU, notamment de son interprétation ou de son
						exécution, relèvera d'une procédure d'arbitrage soumise au règlement
						de la plateforme d'arbitrage choisie d'un commun accord, auquel vous
						adhérerez sans réserve.
					</p>
				</div>

				<div>
					<h2>Portabilité des données</h2>

					<p>
						<strong>Portabilité des données</strong>
					</p>

					<p>
						L'Éditeur s'engage à vous offrir la possibilité de vous faire
						restituer l'ensemble des données vous concernant sur simple demande.
						L'Utilisateur se voit ainsi garantir une meilleure maîtrise de ses
						données, et garde la possibilité de les réutiliser. Ces données
						devront être fournies dans un format ouvert et aisément
						réutilisable.
					</p>
				</div>

				<div>
					<h2>Vidéosurveillance</h2>

					<p>
						Les locaux et les installations de la société Cocoon Space sont
						équipés d’installations de vidéosurveillance pour satisfaire nos
						intérêts commerciaux légitimes, à protéger la sécurité des employés,
						membres, clients de Cocoon Space ainsi que leurs biens. Ces
						enregistrements peuvent être consultés par la société Cocoon Space.
						Cocoon Space peut également mettre ces enregistrements de
						vidéosurveillance à la disposition des membres ainsi que d’autres
						tiers autorisés par la société Cocoon Space. Ces enregistrements
						peuvent être partagés avec les autorités compétentes conformément
						aux lois en vigueur, le cas échéant. Les enregistrements sont
						conservés pendant une période de deux semaines, mais peuvent être
						conservés plus longtemps si la société Cocoon Space ou un membre
						concerné juge cela approprié, par exemple en lien avec une enquête
						ou un incident, ou lorsque les autorités compétentes nous demandent
						de les conserver.
					</p>

					<p>
						Pour exercer vos droits Informatique et Libertés, notamment votre
						droit d'accès aux images qui vous concerne, ou pour toute
						information sur ce dispositif, vous pouvez contacter notre délégué à
						la protection des données en écrivant à dpo@cocoon-space.com ou à
						l'adresse postale suivante :
					</p>

					<div>Cocoon Space</div>

					<div>44 rue du Louvre</div>

					<div>75001 Paris</div>

					<div>France</div>

					<p>
						Vous pouvez introduire une réclamation auprès de la CNIL sur
						cnil.fr/plaintes
					</p>
				</div>
			</MainContainer>
		</>
	)
}

export default Page

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
	props: {
		...(await serverSideTranslations(locale as string, [...defaultI18nNs])),
	},
})
